/**
 * Détecte l'environnement de navigation (mobile, tablette, desktop).
 * Fournit également des informations sur le navigateur.
 */

const navigatorUtils = {
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    browser: '',

    /**
     * Initialise la détection de l'environnement.
     */
    init() {
        const userAgent = navigator.userAgent.toLowerCase();
        const width = window.innerWidth;

        // Détection des appareils
        this.isMobile = /iphone|android(.+)?mobile|windows phone|ipod/.test(userAgent);
        this.isTablet = /ipad|android(?!.*mobile)/.test(userAgent);
        this.isDesktop = !this.isMobile && !this.isTablet;

        // Détection des navigateurs
        if (/chrome|chromium/.test(userAgent)) {
            this.browser = 'Chrome';
        } else if (/firefox/.test(userAgent)) {
            this.browser = 'Firefox';
        } else if (/safari/.test(userAgent) && !/chrome/.test(userAgent)) {
            this.browser = 'Safari';
        } else if (/msie|trident/.test(userAgent)) {
            this.browser = 'Internet Explorer';
        } else if (/edge/.test(userAgent)) {
            this.browser = 'Edge';
        } else {
            this.browser = 'Unknown';
        }

        // Pourcentage basé sur les largeurs d'écran
        const isResponsiveMobile = width <= 768;

        // Précision pour mobile si taille écran correspond
        if (isResponsiveMobile && !this.isTablet) {
            this.isMobile = true;
        }
    },

    /**
     * Vérifie si l'appareil est mobile.
     * @returns {boolean}
     */
    checkMobile() {
        return this.isMobile;
    },

    /**
     * Vérifie si l'appareil est une tablette.
     * @returns {boolean}
     */
    checkTablet() {
        return this.isTablet;
    },

    /**
     * Vérifie si l'appareil est un ordinateur.
     * @returns {boolean}
     */
    checkDesktop() {
        return this.isDesktop;
    },

    /**
     * Retourne le nom du navigateur.
     * @returns {string}
     */
    getBrowser() {
        return this.browser;
    },
};

// Initialisation dès le chargement du script
navigatorUtils.init();

export default navigatorUtils;
